module.exports = __webpack_public_path__ + "static/media/unibestB1.6f2a452e.png";